import { render, staticRenderFns } from "./classSubjectParam.vue?vue&type=template&id=532e0bbc"
import script from "./classSubjectParam.vue?vue&type=script&lang=js"
export * from "./classSubjectParam.vue?vue&type=script&lang=js"
import style0 from "./classSubjectParam.vue?vue&type=style&index=0&id=532e0bbc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports